import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../../components/layout';
import Header from '../../../components/header';
import Icon from '../../../components/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import Drawer from '../../../components/Drawer';
import CreatePurchaseorder from './_components/createPurchaseorder';
import Button from '../../../components/elements/button';
import { Dropdown, Menu } from '../../../components/Dropdown';
import { PAGE_SIZE } from '../../../_common/constant';
import { usePurchaseOrderApi } from '../../../store/api/hooks/purchaseOrderApiHook';
import toast from 'react-hot-toast';
import Pagination from '../../../components/pagination';
import Search from '../../../components/search';
import { downloadExcel, downloadPDF, getPermissionInfo, showLocalDate } from '../../../_common/functions';
import Loader from '../../../components/loader';
import Filters from '../../../components/filters';
import { filterConfigType } from '../../../_config/types';
import { StatusStaticPOCell, StatusStaticPRCell } from '../../../components/elements/function';
import { useCommonApi } from '../../../store/api/hooks/commonApiHook';
import { useSpearPartsApi } from '../../../store/api/hooks/spearPartsApiHook';
import { useDialog } from '../../../store/api/hooks/dialogHook';
import { useAssetsApi } from '../../../store/api/hooks/assetsApiHook';
import ViewPurchaseOrder from './_components/viewPurchaseOrder';
import { URLS } from '../../../_config';
import moment from 'moment';
import CreateReceipt from './../../Inventory/ReceiveStock/_components/createReceipt';
import { useUserSelector } from '../../../store/selectors/userSelector';

const PurchaseOrderPage: React.FC = () => {
    const prorderAPI = usePurchaseOrderApi();
    const commonApi: any = useCommonApi();
    const assetApi: any = useAssetsApi();
    const spearPartsAPI = useSpearPartsApi();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [rowData, setrowData] = useState<any>(null);
    const [filters, setFilters] = useState<any>({});
    const [vendorlist, setvendorList] = useState<any>([]);
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false, locationFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);
    const [selectedPoid, setSelectedPoid] = useState<any>(null);
    const [includeClosePO, setIncludeClosePO] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('purchaseOrderFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('purchaseOrderFilters', JSON.stringify(filters));
        }
    }, [filters]);
    const [selectedPO, setSelectedPO] = useState<any>(null);
    const filtersRef: any = useRef();
    const { confirm } = useDialog();
    const createpoRef = useRef<any>(null);
    const viewpoRef = useRef<any>(null);

    const createReceiptRef = useRef<any>(null);

    const [viewMode, setViewMode] = useState<'view' | 'approve'>('view');
    const navigate = useNavigate();
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const user: any = useUserSelector();

    const handleClose = () => setIsOpen(false);

    const getUserList = (s: string) => {
        return new Promise((resolve, reject) => {
            let payload: any = {};
            if (s !== '') {
                payload.searchParam = s;
            }

            commonApi.GetUserList(payload, (resp: any) => {
                resolve(resp.userList ? resp.userList.map((user: any) => {
                    return {
                        label: user.firstName + " " + user.lastName,
                        value: user.userID,
                    };
                }) : []);
            }, (error: any) => { reject(false) });
        });
    }

    const getVendorList = (s: string) => {

        return new Promise((resolve, reject) => {
            let payload: any = {};
            if (s !== '') {
                payload.searchParam = s;
            }

            assetApi.GetvenderList(payload, (resp: any) => {
                resolve(resp.userList ? resp.userList.map((user: any) => {
                    return {
                        label: user.firstName + " " + user.lastName,
                        value: user.userID,
                    };
                }) : []);
            }, (error: any) => { reject(false) });
        });

    };

    const getSpearPartsList = (s: string) => {
        return new Promise((resolve, reject) => {
            let payload: any = {};
            if (s !== '') {
                payload.searchParam = s;
            }

            spearPartsAPI.getSpearPartsList(payload, (resp: any) => {
                resolve(resp.sparePartsList ? resp.sparePartsList.map((part: any) => {
                    return {
                        label: part.sparePartsName,
                        value: part.partsID,
                    };
                }) : []);
            }, (error: any) => { reject(false) });
        });
    };
    const filterConfig: filterConfigType[] = [
        { name: 'Purchase Order Number', type: 'text', key: 'purchaseOrderCode' },
        { name: 'Items', type: 'dropdown', key: 'partIDs', async: getSpearPartsList as any },
        { name: 'Vendor', type: 'dropdown', key: 'requesterIDs', async: getVendorList as any },
        { name: 'Created by', type: 'dropdown', key: 'addedByIDs', async: getUserList as any },
        { name: 'Approved by', type: 'dropdown', key: 'approverIDs', async: getUserList as any },
        { name: 'Due Date', type: 'date-range', key: 'requiredByStartDate,requiredByEndDate' },
        { name: 'Created Date', type: 'date-range', key: 'addedStartDate,addedEndDate' },
        { name: 'Approval Date', type: 'date-range', key: 'approvalStartDate,approvalEndDate' },
    ]

    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, pinned: "left", width: 50, headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: 'PO No', field: 'purchaseOrderCode', headerClass: 'bg-[#f0f0f0]', pinned: "left", cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer'>{data.value}</p>
                )
            }, onCellClicked: (param: any) => {
                setSelectedPoid(param.data.purchaseOrderID);
                if (param.data.statusID === 2) {
                    setViewMode('approve');
                } else {
                    setViewMode('view');
                }
                viewpoRef.current?.open();
            }
        },
        { headerName: 'Location', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', pinned: "left" },
        {
            headerName: 'PO Date', field: 'addedDate', headerClass: 'bg-[#f0f0f0]', width: 130, pinned: "left", cellRenderer: (data: any) => (
                <p className='hover:text-primary font-normal cursor-pointer'>{showLocalDate(data.value)}</p>
            )
        },
        { headerName: 'Status', field: 'statusName', headerClass: 'bg-[#f0f0f0]', pinned: "left", width: 240, cellRenderer: StatusStaticPOCell },
        {
            headerName: 'Emergency', field: 'isEmergency', headerClass: 'bg-[#f0f0f0]', width: 120, cellRenderer: (params: any) => {
                return params.data.isEmergency
                    ? <span className='inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold bg-red-100 text-red-700'>Emergency</span>
                    : <span className='text-gray-400 text-xs'>—</span>;
            }
        },
        { headerName: 'Vendor', field: 'vendorName', headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: 'Items', field: 'sparePartNames', headerClass: 'bg-[#f0f0f0]', width: 250, cellRenderer: (params: any) => {
                const value = (params.data.typeID == 1 ? params.data.sparePartNames : params.data.assetNames) || '';
                const values: any = value ? value.split(',') : ['--'];
                const more: number = values.length - 1;

                return <div className='text-ellipsis overflow-hidden' title={`${value}`}>{values[0]} {more > 0 ? <span className='-mt-1 badge badge-secondary px-1 text-[0.6rem]'> +{more}</span> : ''}</div>
            }
        },
        { headerName: 'Created By', field: 'requesterName', headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: 'Created Date', field: 'requiredByDate', headerClass: 'bg-[#f0f0f0]', cellRenderer: (data: any) => (
                <p className='hover:text-primary'>{showLocalDate(data.value)}</p>
            )
        },
        { headerName: 'Approved By', field: 'approverName', headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: 'Approval Date', field: 'approvedDate', headerClass: 'bg-[#f0f0f0]', cellRenderer: (data: any) => (
                <p className='hover:text-primary'>{data.value ? showLocalDate(data.value) : '--'}</p>
            )
        },
        {
            headerName: "Actions",
            field: "actions",
            headerClass: 'bg-[#f0f0f0] text-center',
            pinned: "right",
            width: 90,
            cellRenderer: (params: any) => {
                const statusID = params?.data?.statusID;

                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' />
                        <select
                            onChange={(e) => {
                                /* const action = e.target.value;

                                if (!getPermissionInfo(location.pathname, action, user)) {
                                    toast.error(`You don't have ${action} permission`);
                                    e.target.selectedIndex = -1;
                                    return;
                                } */

                                handleActionChange(e, params);
                                e.target.selectedIndex = -1;
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            value={''}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            {[1, 2, 3, 4].includes(statusID) && <option value="edit" disabled={!getPermissionInfo(location.pathname, "Edit", user)}>Edit</option>}
                            {[1, 2].includes(statusID) && <option value="delete" disabled={!getPermissionInfo(location.pathname, "Delete", user)}>Delete</option>}
                            <option value="view">View</option>
                            {statusID === 2 && <option value="approve" disabled={!getPermissionInfo(location.pathname, "Approve PO", user)}>Approve</option>}
                            {[1, 4].includes(statusID) && <option value="send-for-approval">Send For Approval</option>}
                            {[3, 5].includes(statusID) && <option value="receive-stock" disabled={!getPermissionInfo(location.pathname, "Receive Stock", user)}>Receive Stock</option>}
                        </select>
                    </div>
                );
            }
        }
    ];

    // Define row data
    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        // Check permissions for specific actions
        /* if (!getPermissionInfo(location.pathname, action, user)) {
            toast.error(`You don't have ${action} permission`);
            return;
        } */

        switch (action) {
            case "edit":
                setSelectedPoid(rowData.purchaseOrderID);
                createpoRef.current?.open();
                break;
            case "delete":
                confirm({
                    type: 'delete',
                    title: 'Delete Purchase Order',
                    message: 'Are you sure you want to delete this purchase order?',
                    onConfirm: () => {
                        prorderAPI.deleteOrder({ PurchaseOrderID: rowData.purchaseOrderID }, (data: any, msg: any) => {
                            toast.success(msg);
                            GetPurchaseOrderList();
                        }, (error: any) => {
                            toast.error(error);
                        });
                    }
                });
                break;
            case "view":
                setSelectedPoid(rowData.purchaseOrderID);
                setViewMode('view');
                viewpoRef.current?.open();
                break;

            case "approve":
                setSelectedPoid(rowData.purchaseOrderID);
                setViewMode('approve');
                viewpoRef.current?.open();
                break;
            case "send-for-approval":
                confirm({
                    type: 'warn',
                    title: 'Send for Approval',
                    message: 'Are you sure you want to send this purchase order for approval?',
                    onConfirm: () => {
                        getPurchaseOrderDetails(rowData.purchaseOrderID);
                    }
                });
                break;
            case `receive-stock`: {
                setSelectedPO(rowData);
                createReceiptRef.current?.open();
                //console.log("Receive stock", rowData)
                break;
            }
            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };

    const getPurchaseOrderDetails = async (selectedPOid: number) => {
        try {
            const podetails = await new Promise<any>((resolve, reject) => {
                prorderAPI.getOrderById(
                    { purchaseOrderID: selectedPOid },
                    (resp: any) => {
                        if (resp && resp.hasOwnProperty('purchaseOrderID') && +resp.purchaseOrderID > 0) {
                            resolve(resp);
                        } else {
                            toast.error(`Failed to fetch Purchase Order details!`);
                            reject(null);
                        }
                    },
                    (error: any) => {
                        toast.error(error);
                        reject(null);
                    }
                );
            });
            /* const poFile = await new Promise<any>((resolve, reject) => {
                prorderAPI.getFiles(
                    { purchaseOrderID: selectedPOid },
                    (resp: any) => {
                        if (resp && resp.hasOwnProperty('purchaseOrderAttachmentList')) {
                            resolve(resp);
                        } else {
                            toast.error(`Failed to fetch Purchase Order details!`);
                            reject(null);
                        }
                    },
                    (error: any) => {
                        toast.error(error);
                        reject(null);
                    }
                );
            }); */
            let payload: any = {
                purchaseOrderID: podetails.purchaseOrderID,
                purchaseOrderCode: podetails.purchaseOrderCode,
                facilityID: podetails.facilityID,
                subFacilityID: podetails.subFacilityID,
                vendorID: podetails.vendorID,
                taxID: podetails.taxID,
                purchaseOrderTypeID: podetails.typeID,
                purchaseOrderStatusID: 2,
                requesterID: user?.userID || 0,
                requiredByDate: podetails.requiredByDate ?? null,
                notes: podetails.notes,
                purchaseRequestID: podetails.purchaseRequestID,
                purchaseOrderItemList: (podetails.purchaseOrderItemList && podetails.purchaseOrderItemList.length > 0)
                    ? podetails.purchaseOrderItemList.map((item: any) => ({
                        purchaseOrderDetailsID: item.purchaseOrderDetailsID,
                        purchaseOrderID: item.purchaseOrderID,
                        partsID: item.partsID,
                        partsCode: item.partsCode,
                        partName: item.partName,
                        pricePerUnit: item.pricePerUnit,
                        costPerUnit: item.costPerUnit,
                        unitPrice: item.unitPrice,
                        unitID: item.unitID,
                        unitCode: item.unitCode,
                        vendorPartCode: item.vendorPartCode,
                        totalAmount: item.totalAmount,
                        requiredQty: item.requiredQty,
                        deliveredQty: item.deliveredQty
                    }))
                    : null,
                purchaseOrderAsset: podetails.purchaseOrderAsset?.length
                    ? podetails.purchaseOrderAsset.map((asset: any) => ({
                        purchaseOrderID: asset.purchaseOrderID,
                        purchaseOrderAssetID: asset.purchaseOrderAssetID,
                        assetID: asset.assetID,
                        assetName: asset.assetName,
                        unitID: asset.unitID,
                        unitCode: asset.unitCode,
                        unitPrice: asset.unitPrice,
                        requiredQty: asset.requiredQty,
                        deliveredQty: asset.deliveredQty,
                        totalAmount: asset.totalAmount
                    }))
                    : null
            };
            await new Promise((resolve, reject) => {
                prorderAPI.saveOrder(payload, (resp: any) => {
                    if (resp) {
                        resolve(resp);
                        toast.success(resp.message);
                        GetPurchaseOrderList();
                    } else {
                        reject("Failed to save Purchase Order");
                    }
                }, (error: any) => {
                    console.error('Error saving Purchase Order', error);
                });
                /* if (poFile) {
                    let pload = {
                        purchaseOrderID: poFile.purchaseOrderID,
                        purchaseOrderAttachmentList: poFile.purchaseOrderAttachmentList
                    }
                    prorderAPI.savePurchaseOrderFile(pload, (fileResp: any) => {
                        toast.success('Files uploaded successfully');
                    }, (error: any) => {
                        console.error('Error uploading files', error);
                        toast.error('Error uploading files');
                    });
                } */
            }).catch((error: any) => {
                return null;
            });
        } catch (error) {
            console.log("error", error);
            return null;
        }
    }

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false);
        }
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onBulkExportPdf = () => {
        if (!getPermissionInfo(location.pathname, "Export", user)) {
            toast.error("You don't have Export permission");
            return;
        }

        const selectedData = getSelectedRows();
        const payload: any = {  };
        if (selectedData.length > 0) {
            const purchaseOrderIDs = selectedData.map((asset: any) => asset.purchaseOrderID).join(',');
            payload.purchaseOrderIDs = purchaseOrderIDs;
        }
        prorderAPI.exportOrder(
            payload,
            (resp: any) => {
                downloadPDF(resp, 'Purchase_Order')
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };
    
    const onBulkExportCsv = async () => {
        if (!getPermissionInfo(location.pathname, "Export", user)) {
            toast.error("You don't have Export permission");
            return;
        }

        const selectedData = getSelectedRows();
        const payload: any = {  };
        if (selectedData.length > 0) {
            const PurchaseOrderIDs = selectedData.map((asset: any) => asset.purchaseOrderID).join(',');
            payload.purchaseOrderIDs = PurchaseOrderIDs;
        }
        prorderAPI.exportOrderXLS(
            payload,
            (resp: any) => { downloadExcel(resp, 'Purchase_Order') },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const GetPurchaseOrderList = () => {
        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
            statusIDs: `1,2,3,4,5,${includeClosePO ? '6,' : ''}7`
        };

        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        setrowData(null);
        prorderAPI.getOrderList(payload, (resp: any) => {
            setrowData(resp.purchaseOrderList ? resp.purchaseOrderList : []);
            setTotalRecords(resp.totalRecord);

        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        });
    };
    // Call GetPurchaseOrderList only after filters are initialized
    useEffect(() => {
        if (filtersInitialized) {
            GetPurchaseOrderList();
        }
    }, [filters, filtersInitialized]);

    useEffect(() => {
        if (filtersInitialized) {
            GetPurchaseOrderList();
        }

        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
            locationFilter: false,
        });
    }, [currentPage, searchParam, filters, includeClosePO]);



    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const openID = queryParams.get('open');

        if (openID && !isNaN(Number(openID))) {
            setSelectedPoid(Number(openID));
            setViewMode('view');
            viewpoRef.current?.open();
        }
    }, [location.search]);


    return (
        <Layout>
            <Header title='Purchase Order'>
                <Header.Right>
                    <Drawer _ref={createpoRef} isAfterOpenRender={true} onClose={() => {
                        setSelectedPoid(null);
                    }}>
                        <Drawer.Button>
                            <Button disabled={!getPermissionInfo(location.pathname, "Add", user)}>Add New Purchase Order</Button>
                        </Drawer.Button>
                        <Drawer.Content title='Add New Purchase Order' className='!w-[58rem]'>
                            {!getPermissionInfo(location.pathname, "Add", user) ? (
                                <div className="p-4 text-red-500">
                                    You don't have permission to access this form.
                                </div>
                            ) : (
                                <CreatePurchaseorder PoID={selectedPoid} onCreate={() => {
                                    createpoRef.current?.close();
                                    setSelectedPoid(null);
                                    GetPurchaseOrderList();
                                }} onCancel={() => {
                                    setSelectedPoid(null);
                                    createpoRef.current?.close();
                                }} />
                            )}
                        </Drawer.Content>
                    </Drawer>
                    <Drawer _ref={viewpoRef} isAfterOpenRender={true} onClose={() => setSelectedPoid(null)}>
                        <Drawer.Button>
                            <div style={{ display: 'none' }}></div>
                        </Drawer.Button>
                        <Drawer.Content title={viewMode == 'view' ? "View Purchase Order" : "Approve Purchase Order"} className='!w-[45rem] !pr-0'>
                            <ViewPurchaseOrder PoID={selectedPoid} mode={viewMode} onCreate={() => {
                                viewpoRef.current?.close();
                                setSelectedPoid(null);
                                GetPurchaseOrderList();
                            }} onCancel={(trigger: string | null = null) => {
                                viewpoRef.current?.close();
                                if (trigger === 'approve') {
                                    setSelectedPoid(rowData.purchaseOrderID);
                                    setViewMode('approve');
                                    viewpoRef.current?.open();
                                } else if (trigger === 'sendApproval') {
                                    confirm({
                                        type: 'warn',
                                        title: 'Send for Approval',
                                        message: 'Are you sure you want to send this purchase order for approval?',
                                        onConfirm: () => {
                                            getPurchaseOrderDetails(selectedPoid);
                                        }
                                    });
                                } else {
                                    setSelectedPoid(null);
                                    GetPurchaseOrderList();
                                }
                            }} />
                        </Drawer.Content>
                    </Drawer>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary'>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", user)} onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", user)} onClick={onBulkExportPdf}>Export pdf</Menu>
                        </Dropdown.Content>
                    </Dropdown>
                </Header.Right>
            </Header>
            <div>

                <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                    <Pagination
                        perPage={PAGE_SIZE}
                        totalRecords={totalRecords}
                        onPageChange={setCurrentPage}
                        currentPage={currentPage}
                    />
                    <Search onSearch={setSearchParam} placeholder='Search by PO No' />
                </div>
                <div className='bg-[#FAFAFA]'>
                    <div className='flex justify-between px-5 py-2 items-center'>
                        <div className='flex gap-4 px-5 py-2 items-center'>
                            <Button theme='light' onClick={() => filtersRef.current.showModal()}>
                                Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} />
                            </Button>
                            <Dropdown>
                                <Dropdown.Button>
                                    <Button theme='light'>
                                        <Icon name='grlocation' size={1.20} className={filtersApplied.locationFilter ? "text-blue-700" : ""} /> Location <Icon name='arrowdown' size={1.10} />
                                    </Button>
                                </Dropdown.Button>
                            </Dropdown>
                            <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => {
                                setFilters({});
                                localStorage.removeItem('purchaseOrderFilters');
                                setFiltersApplied({ generalFilter: false, locationFilter: false });
                                setCurrentPage(1);
                            }}>
                                Clear Filters
                            </p>
                        </div>

                        <div className='border border-primary rounded-md overflow-hidden flex'>
                    
                            <Button
                                theme={includeClosePO ? 'blue' : 'light'}
                                className='!rounded-none !border-0 px-3'
                                onClick={() => {
                                    setIncludeClosePO(prev => {
                                        const newVal = !prev;
                                        //if (newVal) setIncludePMWO(false); // turn off other
                                        setCurrentPage(1);
                                        return newVal;
                                    });
                                }}
                            >
                                Include Closed PO
                            </Button>
                        </div>

                    </div>

                    <div className="ag-theme-alpine mx-4 h-1/2">
                        <AgGridReact
                            columnDefs={columnDefs as any}
                            rowData={rowData || []}
                            pagination={false}
                            rowSelection="multiple"
                            onGridReady={onGridReady}
                            domLayout="autoHeight"
                            onRowClicked={onRowClicked}
                            loadingOverlayComponent={Loader}
                            noRowsOverlayComponent={() => (
                                <div className="flex items-center justify-center h-full">
                                    <div className="text-center text-gray-500">
                                        <div className="text-lg font-medium">No Data Found</div>
                                    </div>
                                </div>
                            )}
                        />
                    </div>
                </div>
                <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
                {/* Add your component code here */}
            </div>
            <Drawer _ref={createReceiptRef} isAfterOpenRender={true} onClose={() => { }}>
                <Drawer.Button></Drawer.Button>
                <Drawer.Content title='New Receipt' className='!w-[68rem]'>
                    <CreateReceipt po={selectedPO} onCreate={() => {
                        createReceiptRef.current?.close();
                        GetPurchaseOrderList();
                    }} onCancel={() => {
                        createReceiptRef.current?.close();
                    }} />
                </Drawer.Content>
            </Drawer>
        </Layout>
    );
};

export default PurchaseOrderPage;